import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  isAuthenticated: false,
  token: null,
  refresh: null
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.refresh = action.payload.refresh
      state.isAuthenticated = true;
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.refresh = null;
      state.isAuthenticated = false;
    },
    updateToken: (state, action) => {
      state.token = action.payload.token;
    },
    updateRefreshToken: (state, action) => {
      state.refresh = action.payload.refresh;
    },
  },
});

export const { login, logout,updateToken,updateRefreshToken } = authSlice.actions;
export default authSlice.reducer;